




























import { computed, defineComponent, ref, set } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useFilter from "@/hooks/useFilter";
import providers from "@/lib/api";
import { Tab } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import BaseTabs from "@/components/BaseTabs";
import PageTitle from "@/components/PageTitle";
import { AppointmentsTabNameEnum, appointmentsTabs } from "../../config";
import AppointmentsTabController from "../AppointmentsTabController";

export default defineComponent({
  name: "AppointmentsView",
  components: {
    AppointmentsTabController,
    BaseButton,
    BaseIcon,
    PageTitle,
    BaseTabs,
    BasePage,
  },
  props: {
    activeTab: { type: String, required: true },
  },
  setup(props) {
    const { authUserStrict, authorities, isFullCreator } = useAuthUser();
    const { filterMap: filter } = useFilter();
    const filteredTabs = filter(appointmentsTabs, authUserStrict.value, authorities.value);
    const tabsCount = ref<Record<string, number>>({});

    const tabs = computed<Tab[]>(() =>
      Object.keys(filteredTabs).map(key => ({
        text: filteredTabs[key].title,
        value: key,
        count: tabsCount.value[key],
        to: filteredTabs[key].to,
      }))
    );

    const incrementUpcomingCounts = () => {
      set(
        tabsCount.value,
        AppointmentsTabNameEnum.UPCOMING_WITH_ME,
        (tabsCount.value[AppointmentsTabNameEnum.UPCOMING_WITH_ME] || 0) + 1
      );
    };

    const getTabsCount = async () => {
      if (props.activeTab !== AppointmentsTabNameEnum.REQUESTS && !!filteredTabs[AppointmentsTabNameEnum.REQUESTS]) {
        const response = await providers.AppointmentProvider.search({
          size: 1,
          sort: "START_TIME,DESC",
          ...filteredTabs[AppointmentsTabNameEnum.REQUESTS].getData(authUserStrict.value),
        });
        set(tabsCount.value, AppointmentsTabNameEnum.REQUESTS, response.totalRecords);
      }
    };

    getTabsCount();

    return {
      tabs,
      isFullCreator,
      tabsCount,
      filteredTabs,
      incrementUpcomingCounts,
    };
  },
});
